module.exports = __webpack_public_path__ + "media/landing-page/fedex-bubble-98411fba.png";